<template lang="pug">
.send-message-target-check.register-row
  .register-group
    .register-key
      span.key-name 宛先種別
      span.validation-label 必須
      slot(name="question")
    .register-value
      label.register-radio-label(v-if="_enableAllFamily")
        input#type-0.register-radio-form(v-model="_value" name="type" type="radio" :value="'allFamilies'" v-validate="{ required: true }" data-vv-as="宛先種別")
        span.register-radio-text 家族全員
      label.register-radio-label(v-if="_enableFamily")
        input#type-1.register-radio-form(v-model="_value" name="type" type="radio" :value="'families'")
        span.register-radio-text 家族個別
      label.register-radio-label(v-if="_enableOtherUserGroups")
        input#type-2.register-radio-form(v-model="_value" name="type" type="radio" :value="'otherUsers'")
        span.register-radio-text 施設関係者個別
      label.register-radio-label(v-if="enableGroups")
        input#type-3.register-radio-form(v-model="_value" name="type" type="radio" :value="'groups'")
        span.register-radio-text グループ
    .error-messages(v-if="errors.has('type')")
      div(v-for="error in errors.collect('type')")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import { PlanType } from "@/commons/services/Plans";

/**
 * ### メッセージ送信宛先種別コンポーネント
 */
@Component({})
export default class SendMessageTargetCheck extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: SendMessageTarget | null;

  get _enableAllFamily(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToAllFamily;
  }

  get _enableFamily(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToFamily;
  }

  get _enableOtherUserGroups(): boolean {
    return PlanType.LIGHT < userStore.facility.planType && userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToOtherUser;
  }

  get enableGroups(): boolean {
    const permissions = userStore.loginUser.permissions.sendMessagesFunction;
    return (
      PlanType.LIGHT <= userStore.facility.planType &&
      (permissions.useSendTargetToFamilySendMessageGroup ||
        permissions.useSendTargetToOtherUserSendMessageGroup ||
        permissions.useSendTargetToResidentGroup ||
        permissions.useSendTargetToOtherUserGroup)
    );
  }

  get _value(): SendMessageTarget | null {
    return this.value;
  }

  set _value(newValue: SendMessageTarget | null) {
    this.$emit("input", newValue);
    return;
  }
}
export enum SendMessageTarget {
  UNKNOWN = "",
  ALL_FAMILIES = "allFamilies",
  FAMILIES = "families",
  OTHER_USERS = "otherUsers",
  GROUPS = "groups"
}
</script>
